import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'Components/Icon';
import { classnames } from 'Utils/classnames';

const Input = (props, ref) => {
  const { id, maxLength = 4, value, className, onChange, onBlur, onFocus, onClick, disabled } = props;

  const betSlipInputClass = classnames({
    betslip__input: true,
    [className]: className,
    betslip__input__disabled: disabled
  });
  return (
    <div className={ betSlipInputClass }>
      <input
        id={ id }
        type="text"
        inputMode="numeric"
        pattern="\d*"
        maxLength={ maxLength }
        className="betslip__input__value"
        autoComplete="off"
        value={ value }
        onFocus={ onFocus }
        onClick={ onClick }
        onChange={ onChange }
        ref={ ref }
        onBlur={ onBlur }
        disabled={ disabled }
      />

      <Icon className="betslip__input__icon" iconName="svgArrowRight" />
    </div>
  );
};

Input.propTypes = {
  id: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  onClick: PropTypes.func,
  maxLength: PropTypes.number,
  className: PropTypes.string,
  disabled: PropTypes.bool
};

export default React.forwardRef(Input);
